import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getSettingsRequest = {};
var _getSettingsResponse = {};
var _updateSettingsRequest = {};
var _updateSettingsResponse = {};
function resolveWixSocialGroupsApiV2GroupSettingsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/settings-proxy',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/social-groups-proxy/settings',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/social-groups-proxy/settings',
                destPath: '',
            },
            {
                srcPath: '/_api/settings-proxy',
                destPath: '',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/social-groups-proxy/settings',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/settings',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/settings',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/social-groups-proxy/settings',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/social-groups-proxy/settings',
                destPath: '',
            },
        ],
        'groups.wixapps.net': [
            {
                srcPath: '/_api/social-groups-proxy/settings',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/settings',
                destPath: '',
            },
            {
                srcPath: '/social-groups-proxy/api/settings',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/settings',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/social-groups-proxy/settings',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Updates Wix Groups application settings.
 * > **Note:** Only Wix Groups Managers can update the settings.
 */
export function updateSettings(payload) {
    var _a = serializer(_updateSettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateSettingsResponse, {}).fromJSON;
    function __updateSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.groups_app_settings',
            method: 'PATCH',
            methodFqn: 'wix.social.groups.api.v2.GroupSettingsService.UpdateSettings',
            url: resolveWixSocialGroupsApiV2GroupSettingsServiceUrl({
                protoPath: '/v2/settings',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateSettings.fromReq = fromReq;
    __updateSettings.__isAmbassador = true;
    return __updateSettings;
}
/** Retrieves Wix Groups application settings. */
export function getSettings(payload) {
    var _a = serializer(_getSettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSettingsResponse, {}).fromJSON;
    function __getSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.groups_app_settings',
            method: 'GET',
            methodFqn: 'wix.social.groups.api.v2.GroupSettingsService.GetSettings',
            url: resolveWixSocialGroupsApiV2GroupSettingsServiceUrl({
                protoPath: '/v2/settings',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSettings.fromReq = fromReq;
    __getSettings.__isAmbassador = true;
    return __getSettings;
}
//# sourceMappingURL=http.impl.js.map